import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Send, Trash2 } from "lucide-react";

export default function AdminBroadcast() {
  const [form, setForm] = useState({ title: "", body: "", audience: "all" });
  const [busy, setBusy] = useState(false);
  const [list, setList] = useState([]);
  const reload = () => api.get("/broadcasts").then(r => setList(r.data));
  useEffect(() => { reload(); }, []);

  const send = async () => {
    if (!form.title || !form.body) return;
    setBusy(true);
    try { await api.post("/admin/broadcasts", form); toast.success("Broadcast sent"); setForm({ title: "", body: "", audience: "all" }); reload(); }
    catch { toast.error("Send failed"); }
    setBusy(false);
  };

  const remove = async (b) => {
    if (!window.confirm(`Delete broadcast "${b.title}"?`)) return;
    try {
      await api.delete(`/admin/broadcasts/${b.id}`);
      toast.success("Deleted");
      reload();
    } catch (e) { toast.error(e.response?.data?.detail || "Delete failed"); }
  };

  return (
    <div data-testid="admin-broadcast">
      <div className="font-mono-jp text-[10px] uppercase tracking-widest text-[#d7ff00]">MESSAGING CENTER</div>
      <h1 className="font-display text-4xl uppercase">Broadcast to <span className="text-[#d7ff00]">athletes</span></h1>

      <div className="mt-6 bg-[#0a0a0a] border border-[#1f1f1f] p-5">
        <input placeholder="Title (e.g. Saturday 5K Time Trial)" value={form.title} onChange={e => setForm({ ...form, title: e.target.value })}
          className="w-full bg-[#0e0e0e] border border-[#222] focus:border-[#d7ff00] outline-none px-3 py-2.5" data-testid="bcast-title" />
        <textarea rows={4} placeholder="Message body…" value={form.body} onChange={e => setForm({ ...form, body: e.target.value })}
          className="mt-3 w-full bg-[#0e0e0e] border border-[#222] focus:border-[#d7ff00] outline-none px-3 py-2.5" data-testid="bcast-body" />
        <div className="mt-3 flex items-center justify-between gap-3">
          <select value={form.audience} onChange={e => setForm({ ...form, audience: e.target.value })} className="bg-[#0e0e0e] border border-[#222] px-3 py-2" data-testid="bcast-audience">
            <option value="all">All members</option>
            <option value="marathon">Marathon athletes</option>
            <option value="coaching">Coaching clients</option>
          </select>
          <button onClick={send} disabled={busy} className="bg-[#d7ff00] text-black font-display uppercase tracking-wider px-5 py-2.5 hover:bg-white disabled:opacity-50 flex items-center gap-2" data-testid="bcast-send">
            <Send className="w-4 h-4" /> {busy ? "Sending..." : "Send"}
          </button>
        </div>
      </div>

      <div className="mt-8">
        <div className="font-mono-jp text-[10px] uppercase tracking-widest text-[#888]">RECENT</div>
        <div className="mt-3 space-y-3">
          {list.map(b => (
            <div key={b.id} className="bg-[#0a0a0a] border border-[#1f1f1f] p-4" data-testid={`bcast-row-${b.id}`}>
              <div className="flex justify-between gap-3 items-start">
                <div className="font-display text-lg uppercase">{b.title}</div>
                <div className="flex items-center gap-3">
                  <div className="font-mono-jp text-[10px] text-[#666] uppercase tracking-widest">{new Date(b.created_at).toLocaleDateString()}</div>
                  <button onClick={() => remove(b)} className="text-[#ff3b30] hover:text-red-300" title="Delete broadcast" data-testid={`bcast-delete-${b.id}`}>
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>
              <div className="text-sm text-[#bbb] mt-1">{b.body}</div>
              <div className="font-mono-jp text-[10px] text-[#888] uppercase tracking-widest mt-1">{b.audience?.toUpperCase()}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
